<template>
  <div class="company">
    <div class="company_top flex">
      <div class="company_right_img">
        <img src="../../assets/whiteLogo.png" alt="" />
        <img src="../../assets/home/logoBottom.png" alt="" style="margin-top: 8px; width: 90%;"/>
        <p class="tel"><i class="el-icon-headset" style="margin-right: 10px;font-size: 18px"></i>{{ telephone }}</p>
      </div>
      <div class="company_left">
        <div class="companyMes companyJl companyMesNowrap">
          <p class="companyTitle">协议规则</p>
          <div
            class="company_right_p1"
            style="margin-right: 5px;"
            v-for="(items, index) in agreementLink"
            target="_blank"
            :href="items.value"
          >
            <a :href="items.value" target="_blank"
              ><p>{{ items.name }}</p></a
            >
          </div>
        </div>
        <div class="companyJl companyMesNowrap">
          <p class="companyTitle">服务中心</p>
          <div
            class="company_right_p1"
            style="margin-right: 5px;"
            v-for="(items, index) in parkList"
            target="_blank"
            :href="items.value?items.value:null"
          >
            <a :href="items.value?items.value:null" target="_blank"
              ><p>{{ items.name }}</p></a
            >
          </div>
        </div>
        <div class="companyJl">
          <p class="companyTitle">联系我们</p>
          <p class="company_right_p1">客服电话：{{ telephone }}</p>
          <p class="company_right_p1">客服邮箱：{{ email }}</p>
          <p class="company_right_p1" style="width: 390px;">公司地址：{{ dizhivalue }}</p>
        </div>
      </div>
      <div class="company_right_bottom" style="margin-right:20px">
        <p class="companyTitle">水泵云视频号</p>
        <!-- <div class="company_right_two" v-for="code in qrCodeList">
            <div class="company_right_imgs">
              <img :src="code.value" alt="" />
            </div>
            <p>{{code.name}}</p>
          </div> -->
        <img :src="videoCodeInfo.value" alt="" />
      </div>
      <div class="company_right_bottom">
        <p class="companyTitle">水泵云公众号</p>
        <!-- <div class="company_right_two" v-for="code in qrCodeList">
            <div class="company_right_imgs">
              <img :src="code.value" alt="" />
            </div>
            <p>{{code.name}}</p>
          </div> -->
        <img :src="qrCodeList.value" alt="" />
      </div>
    </div>
    <div class="company_Friend">
      <p class="companyTitle">友情链接：</p>
      <a
        style="margin-right: 14px;"
        v-for="(items, index) in linksList"
        target="_blank"
        :href="items.value"
        ><p>{{ items.name }}</p></a
      >
    </div>
    <div class="company_bottom">
      <div class="flex company_bottom_box">
        <p>© 2023 水泵云 All rights reserved</p>
        <p style="margin-left: 20px">运城市盐湖区财惠企业管理咨询服务有限公司</p>
        <img src="../../../static/shenpin.jpg" style="margin-left: 20px">
        <p style="margin-left: 1px">晋公网安备14080202191934号</p>
        <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer" style="margin-left: 20px">晋ICP备2020012630号-2</a>
      </div>
    </div>
  </div>
</template>

<script>
import {getBannerInfo, getIndexDictionaryData} from "../../utils/interface";
import { mapState } from "vuex";

export default {
  name: "Footer",

  data() {
    return {
      /*      //智能制造
      manufacturingList1: [],
      manufacturingList2: [],*/

      //协议 /规则
      agreementLink: [],
      //产业园区
      parkList: [],
      //友情链接
      linksList: [],

      // androidErcode: "",
      // iosErcode: "",

      setIn: null, // 定时器
      telephone: "",
      email: "",
      dizhivalue: "",
      // erweima1:'',
      // erweima2:'',
      // groupName:'',
      // groupName2:'',
      qrCodeList: [],
      videoCodeInfo:{}
    };
  },
  created() {
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
        // this.getManufacturing();
        this.getParkLink();
        this.getAgreementLink();
        this.getLinksList();
        this.getErcode();
        this.getTelephone();
        this.getDizhi();
        this.getEmail();
        // this.getTwoMa()
      }
    }, 500);
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  mounted() {},
  methods: {
    getErcode() {
      getBannerInfo("IOS")
        .then((response) => {
          this.qrCodeList = response;
        })
        .catch(function(error) {
          console.log(error);
        });
      getBannerInfo("SBYSP")
        .then((response) => {
          this.videoCodeInfo = response;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    getLinksList() {
      getIndexDictionaryData({
        groupCode: "YQLJ",
        current: 1,
        pageSize: 10,
      })
        .then((response) => {
          if (response.length > 0) {
            this.linksList = response;
          }
        })
        .catch(function(error) {});
    },

    getParkLink() {
      getIndexDictionaryData({
        groupCode: "CYYQ",
        current: 1,
        pageSize: 10,
      })
        .then((response) => {
          // console.log('jdfka',response );
          if (response.length > 0) {
            this.parkList = response;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    getAgreementLink() {
      getIndexDictionaryData({
        groupCode: "XYGZ",
        current: 1,
        pageSize: 10,
      })
        .then((response) => {
          if (response.length > 0) {
            this.agreementLink = response;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getTelephone() {
      getIndexDictionaryData({
        code: "LXDH",
        current: 1,
        pageSize: 10,
      })
        .then((res) => {
          if (res.length > 0) {
            this.telephone = res[0].value;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getEmail() {
      getIndexDictionaryData({
        code: "KFYX",
        current: 1,
        pageSize: 10,
      })
        .then((res) => {
          if (res.length > 0) {
            this.email = res[0].value;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getDizhi() {
      getIndexDictionaryData({
        code: "GSDZ",
        current: 1,
        pageSize: 10,
      })
        .then((res) => {
          if (res.length > 0) {
            this.dizhivalue = res[0].value;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getTwoMa() {
      getIndexDictionaryData({
        code: "IOS",
        current: 1,
        pageSize: 10,
      })
        .then((res) => {
          this.erweima1 = res[0].value;
          this.groupName = res[0].name;
        })
        .catch(function(error) {
          console.log(error);
        });
      getIndexDictionaryData({
        code: "Android",
        current: 1,
        pageSize: 10,
      })
        .then((res) => {
          this.erweima2 = res[0].value;
          this.groupName2 = res[0].name;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    /*

    getManufacturing() {
      getIndexDictionaryData({
        groupCode: "ZNZZ",
        current: 1,
        pageSize: 20
      }).then((response) => {
        if (response.length > 0) {
          for (let i = 0; i < response.length; i++) {
            if (i < 7) {
              this.manufacturingList1.push(response[i]);
            } else {
              this.manufacturingList2.push(response[i]);
            }
          }
        }
        console.log('url',response)

      }).catch(function (error) {
        console.log(error);
      });
    },
*/
  },
};
</script>

<style scoped lang="less">
.company {
  background: #283541;
  background-size: 100% 100%;
  color: #bababa;
  .companyTitle {
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    margin-bottom: 15px;
  }
  .company_Friend {
    width: 1200px;
    margin: 0 auto;
    margin-top: 40px;
    font-size: 14px;
    border-top: 1px solid #97979769;
    border-bottom: 1px solid #97979769;
    padding-top: 15px;
    display: flex;
    align-items: baseline;
    justify-content: center;
  }
  .company_top {
    width: 1200px;
    margin: 0 auto;
    padding-top: 60px;

    .company_right_img {
      width: 183px;
      margin-right: 50px;
      text-align: right;
      color: #fff;
      font-weight: 600;
      img {
        width: 100%;
      }
      .tel {
        margin-top: 20px;
      }
    }
    .company_left {
      display: flex;
      width: 83%;
    }
    .companyMes {
      padding-left: 50px;
      border-left: 1px solid #97979769;
    }
    .companyMesNowrap {
      white-space: nowrap;
    }

    .company_right_p1 {
      font-size: 14px;
      margin-bottom: 20px;
    }
    .companyJl {
      margin-right: 36px;
    }

    .company_right_bottom {
      text-align: center;

      img {
        width: 100px;
        height: 100px;
        background: #fff;
      }

      p {
        margin-bottom: 10px;
        font-size: 14px;
        color: #cecece;
      }
    }
  }

  .company_center {
    width: 1200px;
    margin: 0 auto;
    font-size: 20px;
    padding-bottom: 24px;

    p {
      margin-bottom: 16px;
    }

    div {
      font-size: 14px;

      span {
        margin-right: 18px;
        color: #bababa;
      }
      span:hover {
        color: #fff;
      }
    }
  }

  .company_bottom {
    margin-top: 40px;
    height: 60px;
    background: #141b21;
    font-size: 12px;
    .company_bottom_box {
      justify-content: center;
      align-items: center;
      line-height: 60px;
      img {
        margin-right: 8px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue